"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HemisphereLight = void 0;
const ILight_1 = require("../../interface/ILight");
const AbstractLight_1 = require("../AbstractLight");
class HemisphereLight extends AbstractLight_1.AbstractLight {
    // #endregion Properties (1)
    // #region Constructors (1)
    constructor(properties) {
        super({
            color: properties.color || '#ffffff',
            intensity: properties.intensity !== undefined ? properties.intensity : 0.5,
            type: ILight_1.LIGHTTYPE.HEMISPHERE,
            name: properties.name,
            order: properties.order,
            id: properties.id
        });
        // #region Properties (1)
        this._groundColor = '#ffffff';
        if (properties.groundColor)
            this._groundColor = properties.groundColor;
    }
    // #endregion Constructors (1)
    // #region Public Accessors (2)
    get groundColor() {
        return this._groundColor;
    }
    set groundColor(value) {
        this._groundColor = value;
        this.updateVersion();
    }
    // #endregion Public Accessors (2)
    // #region Public Methods (1)
    clone() {
        return new HemisphereLight({
            color: this.color,
            groundColor: this.groundColor,
            intensity: this.intensity,
            name: this.name,
            order: this.order
        });
    }
}
exports.HemisphereLight = HemisphereLight;
//# sourceMappingURL=HemisphereLight.js.map